import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getReducedEntityObject, getReducedEntityTypes } from '../../../redux/reducers';
import { overwriteAndReloadEntity, fetchEntityAndOverwrites, selectEntity } from '../../../redux/actions';
import { closePrimaryDrawer } from '../../../redux/actions/drawer';
import constants from '../../../utils/constants';
import RefereeCard from './RefereeCard';

const RefereeCardContainer = ({ match, getEntity, referee, ...rest }) => {
  const { refereeId } = match.params;
  useEffect(() => {
    getEntity(refereeId, constants.entityType.referee);
  }, [refereeId]);

  useEffect(() => {
    closePrimaryDrawer();
  });

  if (referee) {
    return <RefereeCard referee={referee} {...rest} />;
  }
  return null;
};

const mapStateToProps = (state) => {
  const isLoadingOrError = state.refereeOverwrites.loading || state.refereeOverwrites.writing;
  const arePropertiesEdited = Object.values(state.edits.currentEdits).filter((value) => value).length > 0;
  const editsDirty = state.edits.dirty;

  return {
    referee: getReducedEntityObject(state.entities.selectedReferee),
    attributeTypes: getReducedEntityTypes(state.entities.selectedReferee),
    currentEdits: state.edits.currentEdits,
    editsDirty,
    buttonEnable: !isLoadingOrError && arePropertiesEdited && !editsDirty,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getEntity: (entityId, entityType) => dispatch(selectEntity(entityId, entityType)),
  overwriteAndReloadEntity: (refereeId, currentEdits) =>
    dispatch(overwriteAndReloadEntity('referee', refereeId, currentEdits)),
  fetchEntityAndOverwrites: (refereeId) => dispatch(fetchEntityAndOverwrites('referee', refereeId)),
  closePrimaryDrawer: () => dispatch(closePrimaryDrawer()),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RefereeCardContainer)
);
